import { Box } from '@factorialco/deprecated-design-system'
import { VisitDetailsFragment } from 'generated/resources/graphql'

import VisitRow from 'modules/posts/components/Visits/VisitList/VisitRow'

interface Props {
  visits: VisitDetailsFragment[]
}

function Visits({ visits }: Props) {
  return (
    <Box gap="s4" flexDirection="column" maxHeight="s240" overflowY="scroll" gapDivider>
      {visits.map((visit) => (
        <VisitRow key={visit.id} visit={visit} />
      ))}
    </Box>
  )
}

export default Visits
